import styled from 'react-emotion';

const Iframe = styled('iframe')`
  width: calc(100% - 10px);
  border: 0;
  margin: 5px;
  height: 0;
  pointer-events: none;
  overflow: hidden;
`;

export default Iframe;
